export enum BackendErrorType {
  AccessRevoked = 'AccessRevoked',
  PasswordTokenRequired = 'PasswordTokenRequired',
}
